export class ShiftHolderChart {
  name: string;
  qtyFilled: number;
  qtyUnfilled: number;
}
